import React, { useEffect, useState } from "react";
import { useAccountContext } from "../context/AccountContext";
import PromptSpin from "../images/prompts.lottie";
import Logo from "../images/logo_light_grey.png";
import { db } from "../db";

export default function CosyUI() {
    const accountContext = useAccountContext();
    const [loading, setLoading] = useState(true);
    const [animations, setAnimations] = useState(false);
    const url = `https://cosyui.promptus.ai/?accountno=${accountContext.accountDetails.accountNo}`;

    useEffect(() => {
        db.settings.where("key").equals("enable_animations").first(setting => {
            setAnimations(setting?.value || false);
        });
    }, []);

    return (
        <div className="w-full h-full relative">
            {/* Always render iframe but control visibility */}
            <iframe
                src={url}
                className="w-full h-full"
                style={{ display: loading ? 'none' : 'block' }}
                onLoad={() => {
                    console.log('[COSY UI] iframe loaded successfully');
                    setLoading(false);
                }}
                onError={() => {
                    console.error('[COSY UI] iframe failed to load');
                    setLoading(false); // Still hide loader even on error
                }}
            />

            {/* Show loader overlay while loading */}
            {loading && (
                <div className="absolute inset-0 flex flex-col items-center justify-center bg-dark-blue py-32">
                    {animations ?
                        <div className="w-2/3 h-2/3 mx-auto">
                            <lottie-player
                                autoplay
                                loop
                                mode="normal"
                                src={PromptSpin}
                            ></lottie-player>
                        </div>
                    :
                        <img src={Logo} alt={"Promptus Logo"} className="w-2/3 mx-auto animate-pulse" />
                    }
                </div>
            )}
        </div>
    );
} 